import { Input, Button, Form } from "antd"
import { useTenantNavigation } from "../../hooks/useTenantNavigation.js";
import axios from "axios";
import { showLoader } from "../../utils/showloader";
import { trimStringValues } from "../../utils/trimStrings";
import { useTranslation } from 'react-i18next';

const BAKCEND_API = process.env.REACT_APP_BACKEND_API || "https://api.flxflow.com"

const UserLogin = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const formValues = Form.useWatch([], form);
    const navigate = useTenantNavigation();

    const submitHandler = async () => {
        window.close()
        window.location.href = "https://localhost:3000?accessToken=eyahsjdkhaklsdjalksjdmanscmashdfljkas&email=adm10042004@gmail.com"

        // showLoader(true)
        // let loginResp = await loginUser(loginObj)
        // showLoader(false)

        // if (loginResp.success && Object.keys(loginResp.data).length > 0) {
        //     messageF.success(t('Login Successful'))
        //     localStorage.setItem('userRole', 'CONSUMER')
        //     navigate('/consumer/dashboard')
        // } else {
        //     messageF.error(loginResp.message)
        // }
    }

    const loginUser = async (data, type = 'consumer') => {
        data = trimStringValues(data, ["password"])
        let resp = { success: false, message: '' }
        showLoader(true)
        try {

            let response = await axios.post(BAKCEND_API + "/login", data);
            
            // let response = await webService.post(authenticationUrl + "/ocw/utility/" + type + "/login", data, false, false);
            if (response.data && response.data.result) {
                let userDetail = response.data.result
                if (userDetail._id) {
                    localStorage.setItem('userEmail', userDetail.email)
                    localStorage.setItem('accessToken', userDetail.accessToken) 
                    localStorage.setItem("isLoggedIn", "true")
                    window.dispatchEvent(new Event("storage"));
                     showLoader(false)

                    window.close();
                    // window.location.href = "?accessToken=" + userDetail.accessToken + "&email=" + data.email
                }
                resp.success = true
                resp.data = userDetail
                resp.message = response.data.message
            }
        }
        catch (err) {
            resp.message = err?.data?.message
            showLoader(false)
        }
        return resp
    }



    return (
        <div style={{width: "50%", marginLeft: "25%", marginTop:"50px"}}>
            <Form form={form} onFinish={loginUser} layout="vertical">
                <Form.Item label={t('Email')} name="username" rules={[
                    { required: true, whitespace: true, message: 'Email is required'}
                ]}>
                    <Input />
                </Form.Item>
                <Form.Item label={t('Password')} name="password" rules={[
                    { required: true, whitespace: true, message: 'Password is required'}
                ]}>
                    <Input.Password />
                </Form.Item>
                <div style={{ textAlign: "right", marginBottom: 12 }}>
                    <span style={{ color: "#3E44D4", cursor: "pointer" }} onClick={() => navigate("/forgot-password")}>{t('Forgot Password?')}</span>
                </div>
                <Button type="primary" htmlType="submit">{t('Submit')}</Button>
            </Form>
        </div>
    )
}

export default UserLogin